import React from 'react';
import SMDashboardView from '../shared/SMDashboardView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMGraphQLClient from 'lib/SMGraphQLClient';
import 'babel-polyfill';
import SMSubdomainUrlHelper from 'components/helpers/SMSubdomainUrlHelper';
import { companyManagedFragment } from 'fragments';

class SMUDashboardView extends SMDashboardView {
  async requestResource(){
    SMUserResource.getDashboard(this.props.user.username, {}, this.handleResponseDashboard.bind(this));

    let queries;
    queries = {
      filter: 'not_reply',
      start: moment.utc().format("YYYYMMDD"),
      per_page: 10
    };
    SMUserResource.searchReservations(this.props.user.id, queries, this.handleResponsePending.bind(this));

    queries = {
      method: SMConst.ReservationMethod.Reservation,
      start: moment.utc().format("YYYYMMDD"),
      status: 'requested,confirmed',
      per_page: 3
    };
    SMUserResource.searchReservations(this.props.user.username, queries, this.handleResponseRequested.bind(this));

    queries = {
      method: SMConst.ReservationMethod.Reservation,
      start: moment.utc().format("YYYYMMDD"),
      status: 'paid,postpay',
      per_page: 3
    };
    SMUserResource.searchReservations(this.props.user.username, queries, this.handleResponsePaid.bind(this));

    const apiClient = new SMGraphQLClient();
    const query = `
      query {
        viewer {
          companies(filter: MANAGED){
            results{
              ... on Company {
                ${companyManagedFragment}
              }
            }
          }
        }
      }
    `;
    const obj = await apiClient.request(query);

    if (!obj) return false;
    if (obj.errors) {
      console.log(obj.errors);
      return false;
    }

    this.setState({
      companies: obj.data.viewer.companies.results
    });
  }

  handleCreateBusinessAccount() {
    window.location.href = SMSubdomainUrlHelper.businessBaseUrl();
  }

  renderPendingReservations() {

    return (
      <div>
        <h2 className="dashboard-title mb20 mt50">未返信のメッセージ</h2>
        {(()=>{
          if (this.state.pendingReservations.length == 0){
            return <p className="message-supplement mb50">未返信のメッセージはありません。</p>;
          } else {
            const rows = this.state.pendingReservations.map(function(reservation, i){
              const user = reservation.user;
              const owner = reservation.owner;
              const ownerImageUrl = SMFormatHelper.ownerImageUrl(reservation.owner, reservation.owner.profile_image);
              let className = 'dashboard-top__message-list';
              if (!reservation.is_read_message) {
                className += ' is-unread';
              }
              return(
                <li key={reservation.id} className={className}>
                  <div className="dashboard-top__message-list-box dashboard-top__message-icon">
                    {SMAppHelper.ownerIsDeleted(reservation.owner) ?
                      <img src={ownerImageUrl} alt={SMFormatHelper.ownerName(owner)} className="dashboard-top__main-list-icon" />:
                      <a href={Routes.dashboard_message_path(reservation.uid)}>
                        <img src={ownerImageUrl} alt={SMFormatHelper.ownerName(owner)} className="dashboard-top__main-list-icon" />
                      </a>
                    }
                  </div>
                  <div className="dashboard-top__message-list-box dashboard-top__message-name">
                    {(()=>{
                      if (!reservation.is_read_message) {
                        return <i className="fa fa-circle reserve-list__badge"></i>;
                      }
                    })()}
                    {SMAppHelper.ownerIsDeleted(reservation.owner) ?
                      <i>{SMFormatHelper.ownerName(owner)}</i>:
                      <a href={Routes.dashboard_message_path(reservation.uid)} className="link-hover-border">{SMFormatHelper.ownerName(owner)}</a>
                    }
                  </div>
                  <div className="dashboard-top__message-list-box">
                    {SMAppHelper.ownerIsDeleted(reservation.owner) ?
                      <p className="dashboard-top__message-content">{reservation.message.content}</p>:
                      <p className="dashboard-top__message-content"><a href={Routes.dashboard_message_path(reservation.uid)} className="link-hover-border">{reservation.message.content}</a></p>
                    }
                  </div>
                  <div className="dashboard-top__resereve-list-box dashboard-top__message-status">
                    <p className={['reserve-status-icon', SMFormatHelper.statusClassName(reservation)].join(' ')}>{SMFormatHelper.statusText(reservation)}</p>
                  </div>
                  <div className="dashboard-top__message-list-box dashboard-top__message-date">{moment(reservation.message_sent_at).format("YYYY/MM/DD HH:MM")}</div>
                </li>
              );
            });
            return (
              <ul className="dashboard-top__main-listarea">{rows}</ul>
            );
          }
        })()}
        {(()=>{
          if (this.state.hasMorePendingReservations){
            return null;
            // return (
            //   <div className="dashboard-top__buttonarea">
            //     <a href={Routes.dashboard_reservations_path({filter: 'not_reply'})} className="button-blue maincol-buttonarea__button">もっと見る</a>
            //   </div>
            // );
          }
        })()}
      </div>
    );
  }

  renderRequestedReservations() {
    return (
      <div>
        <h2 className="dashboard-title mb20 mt50">未完了の予約リクエスト</h2>
        {(()=>{
          if (this.state.requestedReservations.length == 0){
            return <p className="message-supplement mb50">未完了の予約リクエストはありません。</p>;
          } else {
            const rows = this.state.requestedReservations.map((reservation, i)=>{
              const room = reservation.room;
              const user = reservation.user;
              const owner = reservation.owner;
              const ownerImageUrl = SMFormatHelper.ownerImageUrl(reservation.owner, reservation.owner.profile_image);
              let roomImageUrl = "";
              if (SMAppHelper.ownerIsDeleted(reservation.owner)){
                roomImageUrl = this.props.noRoomImage;
              } else {
                roomImageUrl = SMFormatHelper.roomImageURL(room, {width: 490, height: 490});
              }
              return(
                <li key={reservation.id} className="dashboard-top__user-reserve-list">
                  <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-space">
                    <a href={Routes.dashboard_reservation_path(reservation.uid)}>
                      <img src={roomImageUrl} alt={SMFormatHelper.roomName(room)} className="dashboard-top__user-reserve-space-img" />
                    </a>
                  </div>
                  <div className="dashboard-top__resereve-list-box">
                    <p className="dashboard-top__user-reserve-date">
                      {SMRenderHelper.renderReservationIcon(reservation)}{reservation.reserved_date_text}
                    </p>
                    {SMAppHelper.ownerIsDeleted(reservation.owner) ?
                      <p className="dashboard-top__user-reserve-space-name">{SMFormatHelper.roomName(room)}</p>:
                      <p className="dashboard-top__user-reserve-space-name"><a href={Routes.dashboard_reservation_path(reservation.uid)} className="link-hover-border">{SMFormatHelper.roomName(room)}</a></p>
                    }
                    <p className="dashboard-top__user-reserve-price">{reservation.billing.price_both_text}</p>
                  </div>
                  <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-status">
                    <p className={['reserve-status-icon', SMFormatHelper.statusClassName(reservation)].join(' ')}>{SMFormatHelper.statusText(reservation)}</p>
                  </div>
                  <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-icon">
                    {SMAppHelper.ownerIsDeleted(reservation.owner) ?
                      <img src={ownerImageUrl} alt={SMFormatHelper.ownerName(owner)} className="dashboard-top__main-list-icon" />:
                      <a href={Routes.owner_path(owner.username)}>
                        <img src={ownerImageUrl} alt={SMFormatHelper.ownerName(owner)} className="dashboard-top__main-list-icon" />
                      </a>}
                  </div>
                  {SMAppHelper.ownerIsDeleted(reservation.owner) ?
                    <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-name">{SMFormatHelper.ownerName(owner)}</div>:
                    <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-name">
                      <a href={Routes.owner_path(owner.username)} className="link-hover-border">
                        {SMFormatHelper.ownerName(owner)}
                      </a>
                    </div>
                  }
                </li>
              );
            });
            return(
              <ul className="dashboard-top__main-listarea">{rows}</ul>
            );
          }
        })()}
        {(()=>{
          if (this.state.hasMoreRequestedReservations){
            return (
              <div className="dashboard-top__buttonarea">
                <a href={Routes.dashboard_reservations_path({status: 'requested, confirmed'})} className="button-blue maincol-buttonarea__button">もっと見る</a>
              </div>
            );
          }
        })()}
      </div>
    );
  }

  renderPaidReceipt(reservation) {
    if (!reservation.billing) return null;
    if (reservation.can_show_receipt) {
      return (
        <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-recipt"><a href={Routes.receipt_dashboard_billing_path(reservation.id)} className="button-blue dashboard-top__user-reserve-recipt-button">領収書</a></div>
      );
    }
    else if (reservation.can_show_billing) {
      return (
        <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-recipt"><a href={Routes.dashboard_billing_path(reservation.id)} className="button-blue dashboard-top__user-reserve-recipt-button">請求書</a></div>
      );
    }
    return null;
  }

  renderPaidReservations() {
    return (
      <div>
        <h2 className="dashboard-title mb20 mt50">予約完了</h2>
        {(()=>{
          if (this.state.paidReservations.length == 0){
            return <p className="message-supplement mb50">予約はありません。</p>;
          } else {
            const rows = this.state.paidReservations.map((reservation, i)=>{
              const room = reservation.room;
              const user = reservation.user;
              const owner = reservation.owner;
              const ownerImageUrl = SMFormatHelper.ownerImageUrl(reservation.owner, reservation.owner.profile_image);
              let roomImageUrl;
              if (SMAppHelper.ownerIsDeleted(reservation.owner)){
                roomImageUrl = this.props.noRoomImage;
              } else {
                roomImageUrl = SMFormatHelper.roomImageURL(room, {width: 490, height: 490});
              }
              return(
                <li key={reservation.id} className="dashboard-top__user-reserve-list">
                  <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-space">
                    <a href={Routes.dashboard_reservation_path(reservation.uid)}>
                      <img src={roomImageUrl} alt={SMFormatHelper.roomName(room)} className="dashboard-top__user-reserve-space-img" />
                    </a>
                  </div>
                  <div className="dashboard-top__resereve-list-box">
                    <p className="dashboard-top__user-reserve-date">
                      {SMRenderHelper.renderReservationIcon(reservation)}{reservation.reserved_date_text}
                    </p>
                    {SMAppHelper.ownerIsDeleted(reservation.owner) ?
                      <p className="dashboard-top__user-reserve-space-name">{SMFormatHelper.roomName(room)}</p>:
                      <p className="dashboard-top__user-reserve-space-name"><a href={Routes.dashboard_reservation_path(reservation.uid)} className="link-hover-border">{SMFormatHelper.roomName(room)}</a></p>
                    }
                    <p className="dashboard-top__user-reserve-price">{reservation.billing.price_both_text}</p>
                  </div>
                  {/*<div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-status">
                    <p className={['reserve-status-icon', SMFormatHelper.statusClassName(reservation)].join(' ')}>{SMFormatHelper.statusText(reservation)}</p>
                  </div>*/}
                  <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-icon">
                    {SMAppHelper.ownerIsDeleted(reservation.owner) ?
                      <img src={ownerImageUrl} alt={SMFormatHelper.ownerName(owner)} className="dashboard-top__main-list-icon" />:
                      <a href={Routes.owner_path(owner.username)}>
                        <img src={ownerImageUrl} alt={SMFormatHelper.ownerName(owner)} className="dashboard-top__main-list-icon" />
                      </a>}
                  </div>
                  {SMAppHelper.ownerIsDeleted(reservation.owner) ?
                    <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-name">{SMFormatHelper.ownerName(owner)}</div>:
                    <div className="dashboard-top__resereve-list-box dashboard-top__user-reserve-name"><a href={Routes.owner_path(owner.username)} className="link-hover-border">{SMFormatHelper.ownerName(owner)}</a></div>
                  }
                  {this.renderPaidReceipt(reservation)}
                </li>
              );
            });
            return(
              <ul className="dashboard-top__main-listarea">{rows}</ul>
            );
          }
        })()}
        {(()=>{
          if (this.state.hasMorePaidReservations){
            return (
              <div className="dashboard-top__buttonarea">
                <a href={Routes.dashboard_reservations_path({status: 'paid, postpay'})} className="button-blue maincol-buttonarea__button">もっと見る</a>
              </div>
            );
          }
        })()}
      </div>
    );
  }

  renderBusinessAccounts() {
    if (this.state.companies && this.state.companies.length > 0) {
      return(
        <div className="dashboard-top__business">
          <div className="pt10 pb10 mr20 ml20">
            <h2 className="dashboard-top__business-title">ビジネスアカウント</h2>
              {this.state.companies.map((company) => {
                return(
                  <p className="dashboard-top__business-text link-hover-border"><a href={SMSubdomainUrlHelper.businessSummaryUrl(company.username)}>{company.name}</a></p>
                );
              })}
          </div>
        </div>
      );
    }
  }

  render() {
    const user = this.props.user;
    const name = user.contact_name || user.name;
    const corpName = user.contact ? user.contact.corp_name : '';

    return (
      <div className="dashboard-container clearfix mb30">
        <div className="dashboard-sidecol__top">
          <img src={user.profile_image} alt={name} className="dashboard-top__side-icon" />
          <h2 className="dashboard-top__side-name">{name}</h2>
          <h3 className="dashboard-top__side-company">{corpName}</h3>
          <ul className="dashboard-top__side-menu">
            <li className="dashboard-top__side-menu-list"><a href={Routes.user_path(user.username)} className="link-hover-border">プロフィールを表示</a></li>
            <li className="dashboard-top__side-menu-list"><a href={Routes.dashboard_settings_account_path()} className="link-hover-border">プロフィールを編集</a></li>
          </ul>
          {this.renderBusinessAccounts()}
          {this.props.user.is_corp ?
              <div className="dashboard-top__pr ta-c">
                <p className="dashboard-top__business-supplement">社員の予約や支払いなどを<br />一元管理しませんか？</p>
                <p className="dashboard-top__business-link button-green" onClick={this.handleCreateBusinessAccount.bind(this)}>ビジネスアカウントを作成</p>
              </div> : null
          }
          <div className="dashboard-top__help">
            <h2 className="dashboard-title2 mb20">ヘルプ</h2>
            <h3 className="mb8">予約について</h3>
            <ul className="dashboard-top__help-listarea">
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.ChangeReservation)} className="link-hover-border">予約の変更方法</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.CancelReservation)} className="link-hover-border">予約のキャンセル方法とキャンセル料の種別について</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={Routes.how_to_stay_about_index_path()} className="link-hover-border">当日の流れ</a></p>
              </li>
            </ul>
            <h3 className="mb8">決済について</h3>
            <ul className="dashboard-top__help-listarea">
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.AboutCoupon)} className="link-hover-border">クーポンの利用方法ならびに注意点について</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.PaymentMethod)} className="link-hover-border">決済について詳しく知りたい</a></p>
              </li>
            </ul>
            <h3 className="mb8">領収書・請求書関連</h3>
            <ul className="dashboard-top__help-listarea">
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.IssueReceipt)} className="link-hover-border">領収書の発行方法</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.IssueInvoice)} className="link-hover-border">請求書の発行方法</a></p>
              </li>
              <li className="dashboard-top__help-list">
                <p><a target="_blank" href={SMAppHelper.helpUrl(SMConst.UserHelpPageID.ChangeAddressee)} className="link-hover-border">領収書・請求書の宛名を変更方法</a></p>
              </li>
            </ul>
          </div>
        </div>

        {(()=>{
          if (this.state.completeCounter < this.props.completeMaxCount) {
            return(
              <div className="dashboard-maincol__right" style={{minHeight: '30vh'}} ref="container"></div>
            );
          } else {
            return(
              <div className="dashboard-maincol__right" ref="container">
                {this.renderAnnouncements()}
                {this.renderTodoItems()}
                {this.renderPendingReservations()}
                {this.renderRequestedReservations()}
                {this.renderPaidReservations()}
              </div>
            );
          }
        })()}
      </div>
    );

  }

};
export default SMUDashboardView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/SMUDashboardView.jsx